export const postcodeValidator = (postcode: string) => {
  const regex = /^\d{1,10}$/
  return regex.test(postcode)
}
